import {
  CREATE_ACCOUNT_PENDING,
  CREATE_ACCOUNT_FAIL,
  CREATE_ACCOUNT_SUCCESS,
  GET_ACCOUNT_PENDING,
  GET_ACCOUNT_FAIL,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNTS_PENDING,
  GET_ACCOUNTS_FAIL,
  GET_ACCOUNTS_SUCCESS, UPDATE_ACCOUNT,
} from '../actions/accountActions';


const initialState = {
  account: {
    loading: true,
    loaded: false,
    accepts_sponsorships: false,
    products: [],
    industries: [],
    name: '',
    email: '',
    status: false,
    stat_delivered: 0,
    total_campaigns: 0,
    user: null,
    max_emails_to_a_contact_per_day: null,
    email_delay: 0,
    response_email_forwards: null,
  },
  accounts: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
};

export const accountReducer = (state = initialState.account, action) => {
  switch (action.type) {
    case CREATE_ACCOUNT_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_ACCOUNT_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_ACCOUNT_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_ACCOUNT_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case GET_ACCOUNT_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_ACCOUNT_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_ACCOUNT.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_ACCOUNT.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UPDATE_ACCOUNT.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const accountsReducer = (state = initialState.accounts, action) => {
  switch (action.type) {
    case GET_ACCOUNTS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_ACCOUNTS_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_ACCOUNTS_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};
